export const cibBitrix24 = [
  '32 32',
  "<path d='M22.09 17.926h-1.386v3.716h3.551v-1.386H22.09zm-.616 7.356a4.718 4.718 0 1 1 0-9.436 4.718 4.718 0 0 1 0 9.436m9.195-6A5.19 5.19 0 0 0 23.721 14a5.19 5.19 0 0 0-9.872 1.69A6.234 6.234 0 0 0 15.233 28h14.761c2.444 0 4.425-1.724 4.425-4.425 0-3.497-3.406-4.379-3.75-4.293'/>",
]
